// extracted by mini-css-extract-plugin
module.exports = {"form-group":"LeftSideBar_form-group__2eI72","container":"LeftSideBar_container__1fTY4","containerWithHeader":"LeftSideBar_containerWithHeader__3apVv"};